import {API} from "./Config.local";

class Config{
    get API():string {return API};
}

const config = new Config();

export default config;